import React from 'react';
import { chipClass, Field, inputClass } from '../aiModelUi';
import { StepProps } from './stepTypes';

const PreprocessingStep: React.FC<StepProps> = ({ form, isLight, errors, patch }) => {
  return (
    <div className="space-y-4">
      <p className={`text-[11px] ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>
        Correct columns are not enough if preprocessing differs from training. Record whether the deployed
        endpoint already applies it.
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => patch({ preprocessingIncluded: true })}
          className={`px-3 py-1.5 rounded-md text-xs font-medium border ${chipClass(form.preprocessingIncluded, isLight)}`}
        >
          Yes — included in the deployed model
        </button>
        <button
          type="button"
          onClick={() => patch({ preprocessingIncluded: false })}
          className={`px-3 py-1.5 rounded-md text-xs font-medium border ${chipClass(!form.preprocessingIncluded, isLight)}`}
        >
          No — caller must preprocess
        </button>
      </div>
      {!form.preprocessingIncluded && (
        <Field
          label="Required preprocessing"
          hint="Example: StandardScaler + category encoding required"
          error={errors.preprocessingNotes}
          isLight={isLight}
        >
          <textarea
            value={form.preprocessingNotes}
            onChange={(e) => patch({ preprocessingNotes: e.target.value })}
            rows={3}
            className={inputClass(isLight, Boolean(errors.preprocessingNotes))}
            placeholder="StandardScaler + category encoding required"
          />
        </Field>
      )}
    </div>
  );
};

export default PreprocessingStep;
